// extracted by mini-css-extract-plugin
export var container = "SetStatistics-module--container--6748d";
export var group = "SetStatistics-module--group--5c17a";
export var heading = "SetStatistics-module--heading--7fd13";
export var link = "SetStatistics-module--link--659cb";
export var name = "SetStatistics-module--name--4c6b3";
export var secondaryHeading = "SetStatistics-module--secondaryHeading--087e5";
export var statistic = "SetStatistics-module--statistic--d852f";
export var symbol = "SetStatistics-module--symbol--98769";